import AddressNotes from './AddressNotes';

export default AddressNotes;
